import React from 'react';

const urls = {'Facebook'   : 'https://www.facebook.com/',
              'Instagram'  : 'https://www.instagram.com/',
              'Twitter'    : 'https://www.twitter.com/',
              'Youtube'    : 'https://www.youtube.com/user/',
              'GooglePlus' : 'https://plus.google.com/+'
             };
const colors = {'white'    : 'rgb(255, 255, 255)',
                'orange' : 'rgb(255, 178, 102)',
                'blue'  : 'rgb(0, 213, 255)',
                'red' : 'rgb(255, 102, 102)',
                'lightGrey': 'rgb(211, 211, 211)',
                'grey' : 'rgb(128, 128, 128)'
              };

const createAccount = {'Facebook'   : 'https://www.facebook.com/r.php',
                       'Instagram'  : 'https://www.instagram.com/accounts/emailsignup',
                       'Twitter'    : 'https://www.twitter.com/signup',
                       'Youtube'    : 'https://accounts.google.com/SignUp',
                       'GooglePlus' : 'https://accounts.google.com/SignUp'
                      };

function formatQuery(query) {
  var res = query.toLowerCase();
  res = res.replace(/[?!.& ]/g, '');
  res = res.replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/å/g, 'a');
  return res;
}

function getURL(query, src, cont) {
  var res = {};
  var queryFormatted = formatQuery(query);

  try {
    switch (cont[0]) {
      case 'TAKEN':
        res.html = <a href={urls[src] + queryFormatted} target="_blank"><font color="black">VIEW PROFILE</font></a>;
        res.color = colors.white;
        res.borderColor = colors.red
        res.textColor = colors.red
        break;
      case 'AVAILABLE':
          res.html = <a href={createAccount[src]} target="_blank"><font color="white">CHECK</font></a>;
          res.color = colors.blue;
          res.borderColor = colors.lightGrey
          res.textColor = colors.grey
        break;
      default:
          res.html = <p style={{margin: "0"}}>ERROR</p>;
          res.color = colors.orange;
          res.color = colors.lightGrey
        break;
    }
  }
  catch (err) {
    res.html = <p style={{margin: "0"}}>ERROR</p>;
    res.color = colors.orange;
  }
  return res;
}

export { getURL , formatQuery};



// WEBPACK FOOTER //
// ./client/src/Engines/SocialMediaFunctions.js